import React from 'react';
import './index.css'

const BrandWorkHighlights = () => {
    return (


        <>
            <div className="padding-work font-small-24">
                <h3 className='color-purple font-48 mb-5 text-center'>Work Experience</h3>
                <div className="brand-work">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="color-white">
                                <p className='font-24 weight-700 font-small-24'>Senior Visual Designer<br />
                                    Mayur Hajare Consultancy, Pune</p>
                                <p className='font-24 weight-300'>Sept 2025 - Mar 2025<br />
                                    (6 month Contract)</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='color-white font-24 weight-300 work-custom font-small-24'>
                                <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem' }}>
                                    <li>Created exhibition graphics and collaterals for P&amp;I and CAB, enhancing visual impact.</li>
                                    <li>Led full brand development for MHC’s design division (1by0), including audit, naming, &amp; identity.</li>
                                    <li>Rebuilt Altcore’s brand with a fresh visual identity and strategic direction</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="brand-work">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="color-white">
                                <p className='font-24 weight-700 font-small-24'> Visual Designer
                                    <br />
                                    The Ayurveda Experience, Gurugram</p>
                                <p className='font-24 weight-300'>June 2024 - August 2024</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='color-white font-24 weight-300 work-custom font-small-24'>
                                <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem' }}>
                                    <li>Designed static and motion posts for Instagram and Facebook to strengthen brand presence.</li>
                                    <li>Created targeted Google and Facebook ads to promote key offers.</li>
                                    <li>Updated packaging graphics and labels for better brand alignment.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="brand-work">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="color-white">
                                <p className='font-24 weight-700 font-small-24'>Visual Design Intern <br />
                                    Clay Design Internship, Mumbai</p>
                                <p className='font-24 weight-300'>January 2023 - November 2023</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='color-white font-24 weight-300 work-custom font-small-24'>
                                <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem' }}>
                                    <li>Branding guidelines for Cleartrip and Botim (Publication Design)</li>
                                    <li>Branding route and assisting in brand application of Bal Raksha Bharat and The School of Raya.</li>
                                    <li>Illustration System for Bal Raksha Bharat with Social Media as well as Publication application.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="brand-work">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="color-white ">
                                <p className='font-24 weight-700 font-small-24'>Freelancing</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='color-white font-24 weight-300 work-custom font-small-24'>
                                <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem' }}>
                                    <li>Developed branding for Mindshare Solutions, a marketing firm based in Pune.</li>
                                    <li>Created visual identity for Enajori Music Festival in Guwahati.</li>
                                    <li>Designed and developed an inclusive illustration system for Prabhat Foundation.</li>
                                    <li>Built branding for Magic Mystery, an online and offline accessory store.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="brand-work">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="color-white">
                                <p className='font-24 weight-700'>Title Design</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className='color-white font-24 weight-300 work-custom custom-last-div'>
                                <ul style={{ listStyle: 'disc', paddingLeft: '1.5rem' }}>
                                    <li><strong>Athithi Daivo Bhava</strong> – Animated short by Pranav Holla</li>
                                    <li><strong>Of Men & Puppets</strong> – Graphic novel by Rohit Issac Thomas</li>
                                    <li><strong>Babi</strong> – Short films by Maithili Ajay Phatak</li>
                                    <li><strong>Amala</strong> – Short films by Maithili Ajay Phatak</li>
                                    <li><strong>Staged</strong> – Short film by Saundary Toppo</li>
                                    <li><strong>Darar</strong> – Animated short by Gaurav Pati</li>
                                    <li><strong>Rama</strong> – Graphic Novel by Dipankar Talukdar</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
           </div>

        </>
    );
};

export default BrandWorkHighlights;
